// src/components/LAB/LABActivityModal.js
// Modal de actividad para LAB — independiente de TZone
import React from 'react';
import LABRunningModal from './LABRunningModal';
import LABSwimmingModal from './LABSwimmingModal';
import LABStrengthModal from './LABStrengthModal';
import LABCyclingModal from './LABCyclingModal';

const LABActivityModal = (props) => {
  const selectedDate = props.activityType?.selectedDate || props.activityType?.date || props.activityType?.start;
  
  const handleDelete = async (id) => {
    if (!id) return;
    const token = localStorage.getItem('token');
    try {
      await fetch(`${(process.env.REACT_APP_API_URL || 'https://tzone-web-backend-1-2ev5.onrender.com')}/api/activities/delete/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      props.onHide?.();
      props.onDelete?.();
    } catch(e) { console.error('Error al eliminar:', e); }
  };
  const { activityType } = props;
  if (!activityType) return null;
  const type = (activityType.type || '').toLowerCase();
  switch (type) {
    case 'nadar':    return <LABSwimmingModal {...props} selectedDate={selectedDate} onDelete={handleDelete} />;
    case 'fuerza':   return <LABStrengthModal {...props} selectedDate={selectedDate} onDelete={handleDelete} />;
    case 'ciclismo': return <LABCyclingModal {...props} selectedDate={selectedDate} onDelete={handleDelete} />;
    default:         return <LABRunningModal {...props} selectedDate={selectedDate} onDelete={handleDelete} />;
  }
};

export default LABActivityModal;
